<div class="modal-body text-center p-4">
  <!-- Inline SVG: the modal shows when the network is down, so no asset can be fetched -->
  <svg class="error-icon" width="64" height="64" viewBox="0 0 64 64" aria-hidden="true">
    <circle cx="32" cy="32" r="32" fill="#FDE5E5" />
    <path d="M24 24l16 16M40 24L24 40" stroke="#EF2727" stroke-width="3" stroke-linecap="round" />
  </svg>
  <h4 class="fs-20 fw-600 theme-text mt-3">Something went wrong</h4>
  <p class="fs-14 text-grey mb-4">We were unable to reach the server. Please reload the page and try again.</p>
  <button type="button" class="btn btn-primary w-100" (click)="reload()">Reload</button>
</div>
